import React from 'react';
import './ItemsProgress.scss';

export function ItemsProgress({ 
  active = 1, 
  steps = ['BAG', 'ADDRESS', 'PAYMENT'],
  className = '',
  showLines = true 
}) {
  
  const getStepClass = (index) => {
    const stepNumber = index + 1;
    let classes = 'step';
    
    if (stepNumber < active) {
      classes += ' completed';
    } else if (stepNumber === active) {
      classes += ' active';
    }
    
    return classes;
  };

  const getLineClass = (index) => {
    const stepNumber = index + 1;
    return stepNumber < active ? 'step-line completed-line' : 'step-line';
  };

  return (
    <div className={`checkout-steps-container design-1 ${className}`}>
      <div className="checkout-steps">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className={getStepClass(index)}>
              <div className="step-label">{step}</div>
              {showLines && index < steps.length - 1 && (
                <div className={getLineClass(index)}></div>
              )}
            </div>
            {showLines && index < steps.length - 1 && (
              <div className="step-connector">
                <div className="connector-line"></div>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}